import React, { useState, useEffect } from "react";
import stylesheet from "./services.module.css";
import Product_image1 from "../../../assets/images/weed_product.webp";
import Product_image2 from "../../../assets/images/CBD2.webp";
import Product_image3 from "../../../assets/images/CBD3.webp";
import Product_image4 from "../../../assets/images/CBD4.webp";
import ProductCard from "../../webincludes/productcard/index";
import Input from "../../component/input/index";
import Footer from "../../webincludes/footer/index";
import Header from "../../webincludes/header/index";
import { getTheme } from "../../../actions/localtheme";
import { connect } from "react-redux";
import Wiggle from "../../component/Wiggle/Wiggle";
import Aboutus from "../about/index";

const affilate = () => {
  return <Aboutus />;
};

export default affilate;
